import createRoute        from '@widesk-ui/tools/createRoute';
import ClientRequestModel from '@models/account/ClientRequestModel';

export default createRoute.dashboard('/client_requests', 'account', 'ClientRequestDashboard', ClientRequestModel.localize());
